import React, {useEffect} from "react";
import "../../Stylesheets/index.css";
import LeftNavbar from "./leftNavbar";
import {useDispatch, useSelector} from "react-redux";
import BillingPageWrapper, {BILLING_COMPONENT} from "../Billing/billingPageWrapper";
import ProfilePageWrapper, {PROFILE_COMPONENT} from "../Profile/profilePageWrapper";
import PaymentsWrapper, {PAYMENT_COMPONENT} from "../Payments/paymentsWrapper";
import {getEnterpriseDetails} from "../../Actions/enterpriseUserDetailsAction";
import NotificationsWrapper, { NOTIFICATIONS_COMPONENT } from "../Notifications/notificationsWrapper";
import { getReviewNotificationEmails, getWeeklyNotificationEmails } from "../../Actions/notificationEmailsActions";
import ReportsWrapper, { REPORTS_COMPONENT } from "../Reports/reportsWrapper";
import { getCompanyConfigurations } from "../../Actions/companyConfigurationsActions";
import { fullScreenLayoutSelector, selectedComponentSelector } from "../../Reducers/selectedComponentReducer";
import { getAllCompanyReviewSummary } from "../../Actions/allCompanyReviewSummaryAction";
import AiInsightWrapper, { AI_INSIGHTS } from "../AiInsights/AiInsightWrapper";
import ReviewsPageWrapper, { REVIEWS } from "../Reviews/ReviewsPageWrapper";
import { getPlans } from "../../Actions/plansAction";
import { REVIEW_DEFAULT_OPTION } from "../AiInsights/ReviewInsightsList";
import { getReviewAiInsights } from "../../Actions/reviewAiInsightsAction";
import { getCompaniesIdToken } from "../../Actions/companiesIdTokenAction";
import styles from "./layout.module.css";
import EnterpriseHeader from "./enterpriseHeader";
import { enterpriseDetailsSelector } from "../../Reducers/enterpriseDetailsReducer";
import { useFetchCardsQuery } from "../../Apis/cardApi";
import { useFetchAchQuery } from "../../Apis/achApi";
import { getUsers } from "../../Actions/userActions";
import AccountsWrapper, { ACCOUNTS_COMPONENT } from "../Accounts/AccountsWrapper";
import { cx } from "../../Util/classHelpers";
import SettingsWrapper, { SETTINGS_COMPONENT } from "../Settings/SettingsWrapper";
import { ownPermissionsSelector } from "../../Reducers/ownRoleReducer";
import { useFetchChargesQuery } from "../../Apis/stripeChargesApi";
import OrdersWrapper, { ORDERS_COMPONENT } from "../Orders/OrdersWrapper";
import { useFetchPendingUserInvitationsQuery } from "../../Apis/userInvitationsApi";
import { useFetchPaymentSourcesQuery } from "../../Apis/paymentSourceApi";
import PaymentPendingBanner from "../CommonComponents/PaymentPendingBanner";

const tabConfig = {
    [ACCOUNTS_COMPONENT]: {  
        Component: AccountsWrapper,
        padding: true,
    },
    [BILLING_COMPONENT]: {  
        Component: BillingPageWrapper,
        padding: true,
    },
    [PAYMENT_COMPONENT]: {  
        Component: PaymentsWrapper,
        padding: true,
    },
    [PROFILE_COMPONENT]: {  
        Component: ProfilePageWrapper,
        padding: true,
    },
    [NOTIFICATIONS_COMPONENT]: {  
        Component: NotificationsWrapper,
        padding: true,
    },
    [REPORTS_COMPONENT]: {  
        Component: ReportsWrapper,
        padding: true,
    },
    [AI_INSIGHTS]: {  
        Component: AiInsightWrapper,
        padding: true,
    },
    [REVIEWS]: {  
        Component: ReviewsPageWrapper,
        padding: true,
    },
    [SETTINGS_COMPONENT]: {  
        Component: SettingsWrapper,
        padding: true,
    },
    [ORDERS_COMPONENT]: {  
        Component: OrdersWrapper,
        padding: false,
    },
};

const Layout = ({children, tabSettings}) => {
    const fullScreen = useSelector(fullScreenLayoutSelector);

    return (
        <div className={styles.fullContainer}>
            <PaymentPendingBanner />
            {!fullScreen && <EnterpriseHeader />}
            <div className={styles.contentContainer}>
                {!fullScreen && <LeftNavbar />}
                <div className={cx(fullScreen ? styles.fullScreenContent : styles.contentBody, tabSettings.padding ? styles.contentBodyPadding : "")}>
                    {children}
                </div>
            </div>
        </div>
    )
}

const EnterprisePortalWrapper = () => {
    const selectedComponent = useSelector(selectedComponentSelector);
    const enterpriseDetails = useSelector(enterpriseDetailsSelector);
    const ownPermissions = useSelector(ownPermissionsSelector);

    const dispatch = useDispatch();
    
    // RTK Query hooks for cards and ACH - conditionally enabled based on permissions
    const canManagePayments = ownPermissions?.canManagePayments() ?? false;
    const canManageUsers = ownPermissions?.canManageUsers() ?? false;
    useFetchCardsQuery(undefined, { skip: !canManagePayments || enterpriseDetails === null });
    useFetchChargesQuery(undefined, { skip: !canManagePayments || enterpriseDetails === null });
    useFetchAchQuery(undefined, { skip: !canManagePayments || enterpriseDetails === null });
    useFetchPaymentSourcesQuery(undefined, { skip: !canManagePayments || enterpriseDetails === null });
    useFetchPendingUserInvitationsQuery(undefined, { skip: !canManageUsers || enterpriseDetails === null });

    useEffect(() => {
        dispatch(getPlans());
        dispatch(getEnterpriseDetails());
        dispatch(getCompanyConfigurations());
        dispatch(getAllCompanyReviewSummary());
        dispatch(getReviewAiInsights(REVIEW_DEFAULT_OPTION));
        dispatch(getCompaniesIdToken());
    }, [dispatch])

    useEffect(() => {
        if (enterpriseDetails === null) return;
        if (ownPermissions.canManageNotifications()) {
            dispatch(getWeeklyNotificationEmails());
            dispatch(getReviewNotificationEmails());
        }
        if (ownPermissions.canManageUsers()) {
            dispatch(getUsers());
        }
        
    }, [enterpriseDetails, ownPermissions, dispatch]);

    const tabSettings = tabConfig[selectedComponent] || {};
    const SelectedComponent = tabSettings.Component;


    if (enterpriseDetails === null) return <></>

    return (
        <Layout tabSettings={tabSettings}>
            {SelectedComponent ? <SelectedComponent /> : null}
        </Layout>
    )
}

export default EnterprisePortalWrapper;
